import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Form, Input, Col, Row, Select } from 'antd';
import Icon from '@ant-design/icons';
import { useTheme } from '../../../../context/ThemeContext';
import {
  DARK,
  SOS_CALL_TYPES,
  SOS_TYPES,
} from '../../../../utilities/constants';
import { ReactComponent as SelectDropdownSvg } from '../../../../assets/icons/select-dropdown.svg';
import { ReactComponent as SelectDropdownBlackSvg } from '../../../../assets/icons/select-dropdown-black.svg';
import DescriptionFormItem from '../../../../components/DescriptionFormItem/DescriptionFormItem';
import SOModalLayout from './SOModalLayout';
import EmptyCard from '../../../../components/EmptyCard/EmptyCard';
const { Text } = Typography;

const callStatusList = [
  { value: SOS_CALL_TYPES.FALSE_ALERT, label: SOS_CALL_TYPES.FALSE_ALERT },
  { value: SOS_CALL_TYPES.GENUINE_CALL, label: SOS_CALL_TYPES.GENUINE_CALL },
];
const sosTypeList = [
  { value: SOS_TYPES.MEDICAL_EMERGENCY, label: SOS_TYPES.MEDICAL_EMERGENCY },
  { value: SOS_TYPES.ROAD_ACCIDENT, label: SOS_TYPES.ROAD_ACCIDENT },
  { value: SOS_TYPES.FIGHT, label: SOS_TYPES.FIGHT },
  { value: SOS_TYPES.OTHERS, label: SOS_TYPES.OTHERS },
];

const SOActionModal = ({
  isModalOpen,
  setIsModalOpen,
  clickedSosData,
  updateSOSList,
}) => {
  const { theme } = useTheme();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  return (
    <SOModalLayout
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      form={form}
      type={'action'}
      loading={loading}
      setLoading={setLoading}
      title={'Action Form'}
      footerButtonText={'Submit'}
      clickedSosData={clickedSosData}
      updateSOSList={updateSOSList}
    >
      <Row className="full-width">
        <Col xs={24} lg={12}>
          <Form.Item
            name="reporter"
            rules={[
              {
                required: true,
                message: 'Please enter reporter',
              },
            ]}
            label={<Text strong>Reporter</Text>}
          >
            <Input autoSize placeholder="e.g: John Doe" />
          </Form.Item>
        </Col>
      </Row>
      <Row
        className="full-width"
        gutter={[
          { xs: 0, lg: 10 },
          { xs: 10, lg: 10 },
        ]}
      >
        <Col xs={24} lg={12} style={{ paddingLeft: 0 }}>
          <Form.Item
            name="callType"
            rules={[
              {
                required: true,
                message: 'Please enter call type',
              },
            ]}
            label={
              <Text strong style={{ marginTop: '4px' }}>
                Call Type
              </Text>
            }
          >
            <Select
              placeholder="--Select--"
              options={callStatusList}
              size="large"
              className="custom-select-dropdown"
              suffixIcon={
                <Icon
                  component={
                    theme === DARK ? SelectDropdownSvg : SelectDropdownBlackSvg
                  }
                  style={{
                    pointerEvents: 'none',
                  }}
                />
              }
              notFoundContent={<EmptyCard />}
            />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12} style={{ paddingRight: 0 }}>
          <Form.Item
            name="sosType"
            rules={[
              ({ getFieldValue }) => ({
                required: getFieldValue('callType') === 'Genuine call',
                message: 'Please enter SOS Type',
              }),
            ]}
            label={
              <Text strong style={{ marginTop: '4px' }}>
                SOS Type
              </Text>
            }
          >
            <Select
              placeholder="--select--"
              options={sosTypeList}
              size="large"
              className="custom-select-dropdown"
              suffixIcon={
                <Icon
                  component={
                    theme === DARK ? SelectDropdownSvg : SelectDropdownBlackSvg
                  }
                  style={{
                    pointerEvents: 'none',
                  }}
                />
              }
              notFoundContent={<EmptyCard />}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row className="full-width">
        <DescriptionFormItem />
      </Row>
      <Row className="full-width">
        <Col xs={24} lg={12}>
          <Form.Item
            name="assign_to"
            label={
              <Text strong style={{ marginTop: '4px' }}>
                Assign To
              </Text>
            }
          >
            <Input autoSize placeholder="e.g: John Doe" />
          </Form.Item>
          <Text style={{ fontSize: '12px' }}>{`(optional)`}</Text>
        </Col>
      </Row>
    </SOModalLayout>
  );
};

SOActionModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  clickedSosData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  updateSOSList: PropTypes.func.isRequired,
};

export default React.memo(SOActionModal);
